import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import CompanyEditInnerComponent from './CompanyEditInner.component';
import CompanyDataProvider from '../../../Utils/Companies/CompanyDataProvider';
const HelmetHelper = React.lazy(
  () => import('../../../Components/PageHelmet/HelmetHelper.component')
);
import FormLoading from '../../../Components/LoadingPages/LoadingForm.component';

// Form for editing a company
const EditCompany = () => {
  const { id } = useParams();

  return (
    <AuthCheckAdmin>
      <Suspense fallback={<p>Loading page...</p>}>
        <HelmetHelper
          title="Edit Company"
          description="Form to edit a company"
        />
      </Suspense>
      <CompanyDataProvider id={id} loadingComponent={FormLoading}>
        {(company) => {
          return <CompanyEditInnerComponent c={company.company[0]} />;
        }}
      </CompanyDataProvider>
    </AuthCheckAdmin>
  );
};

export default EditCompany;
